import React, { Fragment, useEffect, useState } from 'react';
import { useTable, useSortBy, useFilters, useExpanded, usePagination, useAsyncDebounce } from 'react-table';
import { Table, Col, CardHeader, CardBody, Card, Progress, Button } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import Select from 'react-select';

import Pagination from './Pagination/Pagination';
import { DefaultColumnFilter } from './filters';
import { CommonLoadingSkelton, TableSkelton } from './skelton';
import { getPartOfTheStrUptoRequiredIndex } from '../../common/utils';
import { convertUTCDateToLocalDate, dateInRequireFormate } from './Util';
import { useTrans } from '../Hooks/UserHooks';
import { useSelector } from 'react-redux';
import { SelectSearchValInStore } from '../../Store/commonStore/selectors';
import { selectCustomStyles } from '../constants/styles';
import { memberStatusObj } from '../../pages/Dashboard/utils';

const labelsForRowsperPage = [
    { value: 10, label: 10 },
    { value: 25, label: 25 },
    { value: 50, label: 50 },
    { value: 75, label: 75 },
    { value: 100, label: 100 },
    { value: 200, label: 200 },
    { value: 300, label: 300 },
    { value: 400, label: 400 },
    { value: 500, label: 500 }
];

const DashboardTable = ({
    tabelID,
    cardTitle,
    cardHeight,
    cardCSS,
    columns,
    hiderHeader,
    data,
    hasToogle,
    customPageSize,
    showRowsPerPage = true,
    tableClass,
    theadClass,
    trClass,
    divClass,
    emptyMessage,
    isFullScreenMode,
    toggleFullscreen,
    loading,
    allDataObj,
    onPageChange,
    globalSelectConfig,
    buttonLabel,
    showButtonLabel,
    onGlobalBtnClick,
    routeURLID,
    handleActionClick,
    handleShowCanvas,
    generateButton,
    // setRecordsPerPage,
    tableLoader,
    mandate = false,
    pageNo = 1,
    handleSearch,
    customActionsTemplate
}) => {
    const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow, gotoPage, rows, setPageSize, state } = useTable(
        {
            columns,
            data,
            defaultColumn: { Filter: DefaultColumnFilter },
            initialState: { pageIndex: 0, pageSize: customPageSize } // , sortBy: [{ desc: true }]
        },
        useFilters,
        useSortBy,
        useExpanded,
        usePagination
    );
    const t = useTrans('translation');

    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const linkOutreachId = params.get('otureachId');

    const [activePage, setActivePage] = useState(pageNo);
    const [rowsPerPage, setRowsPerPage] = useState({ value: 10, label: 10 });
    const [searchText, setSearchText] = useState('');
    const [recPerPageOptions] = useState(labelsForRowsperPage);
    const [eligibleMember, setEligibleMember] = useState();
    const roleVal = useSelector((state) => SelectSearchValInStore(state, 'roleVal'));
    const roleID = roleVal?.roleID;

    useEffect(() => {
        setActivePage(pageNo);
    }, [pageNo]);

    const handleRowsPerpage = (e) => {
        setRowsPerPage(e);
        setPageSize(e.value);
        setActivePage(1);
        const pg = 0;
        gotoPage(pg);
        // setRecordsPerPage && setRecordsPerPage(e.value);
        handleSearch && handleSearch(searchText, e.value, 'rowsPerPage');
        onPageChange && !handleSearch && onPageChange(1, e.value);
    };

    function recordsPerPageTemplate() {
        return (
            <div className="me-5 d-flex align-items-center ms-auto">
                <span className="me-2">Rows Per Page </span>
                <Select
                    value={rowsPerPage}
                    onChange={(e) => handleRowsPerpage(e)}
                    options={recPerPageOptions}
                    components={{
                        IndicatorSeparator: () => null
                    }}
                    menuPlacement="top"
                    id="rowsPerPage"
                />
            </div>
        );
    }

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
        const pg = pageNumber ? Number(pageNumber) - 1 : 0;
        gotoPage(pg);
        onPageChange && onPageChange(pageNumber, rowsPerPage.value);
    };
    const onActionClick = (cell, row, index, actionType) => {
        handleActionClick(cell, row, index, actionType);
    };

    const prepareCustomBody = (cell, row, index) => {
        let body = undefined;

        switch (cell?.column?.fieldType) {
            case 'date':
                let dateFormat = cell?.column?.toLocale
                    ? convertUTCDateToLocalDate(row?.original?.[cell?.column?.id], 'm/d/y')
                    : dateInRequireFormate(row?.original?.[cell?.column?.id], 'm/d/y');
                body = <div className="label">{dateFormat}</div>;
                break;
            case 'UtcToLocalDate':
                let dtFormat = cell?.column?.format ? cell?.column?.format : 'm/d/y';
                let dateFor = cell?.column?.toLocale
                    ? convertUTCDateToLocalDate(row?.original?.[cell?.column?.id], dtFormat, true)
                    : dateInRequireFormate(row?.original?.[cell?.column?.id], dtFormat);
                body = <div className="label">{dateFor ? dateFor : 'NA'}</div>;
                break;

            case 'actions':
                body = (
                    <div className="d-flex align-items-center">
                        {cell?.column?.isEdit && row?.original?.canView && (
                            <i
                                className="ri-eye-line align-middle fs-18 cursor-pointer primary-color text-primary"
                                onClick={() => onActionClick(cell, row, index, 'view')}
                                id={tabelID + 'view'}
                            ></i>
                        )}
                        {cell?.column?.isEdit && row?.original?.canEdit && (
                            <i
                                className="ri-pencil-line align-middle fs-18 cursor-pointer primary-color text-primary ms-2"
                                onClick={() => onActionClick(cell, row, index, 'edit')}
                                id={tabelID + 'edit'}
                            ></i>
                        )}
                        {cell?.column?.isDelete && row?.original?.canDelete && (
                            <i
                                className="ri-delete-bin-line align-middle ms-2 cursor-pointer text-primary"
                                id={tabelID + 'remove'}
                                onClick={() => onActionClick(cell, row, index, 'delete')}
                            ></i>
                        )}
                    </div>
                );
                break;
            case 'columnActions':
                body = (
                    <>
                        {cell?.column?.isEdit && (
                            <i
                                className="ri-pencil-line align-middle fs-18 cursor-pointer primary-color text-primary me-1"
                                onClick={() => onActionClick(cell, row, index, 'edit')}
                                id={tabelID + 'edit'}
                            ></i>
                        )}
                        {cell?.column?.isView && (
                            <i
                                className="ri-eye-line align-middle fs-18 cursor-pointer primary-color text-primary"
                                onClick={() => onActionClick(cell, row, index, 'edit')}
                                id={tabelID + 'view'}
                            ></i>
                        )}
                        {cell?.column?.isDelete && (
                            <i
                                className="ri-delete-bin-line align-middle ms-2 cursor-pointer text-primary"
                                onClick={() => onActionClick(cell, row, index, 'delete')}
                                id={tabelID + 'remove'}
                            ></i>
                        )}
                    </>
                );
                break;
            case 'customActions':
                body = <>{customActionsTemplate(cell, row, index)}</>;
                break;
            case 'amount':
                body = <div>${row?.original?.[cell?.column?.id]}</div>;
                break;
            case 'status':
                body = (
                    <div
                        className={`lh-sm badge ${
                            row?.original?.status?.toLowerCase() === 'completed' ||
                            row?.original?.status?.toLowerCase() === 'approved' ||
                            row?.original?.status?.toLowerCase() === 'samsubmitted'
                                ? 'badge-soft-success'
                                : row?.original?.status.toLowerCase() === 'inprogress'
                                ? 'badge-soft-warning'
                                : 'badge-soft-danger'
                        }`}
                    >
                        {cell?.render('Cell')}
                    </div>
                );
                break;
            case 'memberStatus':
                body = (
                    <div title={row?.original?.memberStatus ? memberStatusObj[row?.original?.memberStatus] : '-'}>
                        {row?.original?.memberStatus ? memberStatusObj[row?.original?.memberStatus] : '-'}
                    </div>
                );
                break;
            case 'approveButton':
                body = (
                    <>
                        <Button
                            type="button"
                            size="sm"
                            color="soft-success"
                            // outline="success"
                            onClick={() => onActionClick(cell, row, index, 'approve')}
                            title={'Approve Member'}
                            id={'approve' + tabelID}
                        >
                            <div className="d-flex align-items-center">
                                <i className="ri-check-double-line fs-20 fw-medium" />
                            </div>
                        </Button>
                    </>
                );
                break;
            case 'viewNeeds':
                body = (
                    <>
                        <Button
                            type="button"
                            size="sm"
                            color="soft-info"
                            // outline="success"
                            onClick={() => onActionClick(cell, row, index, 'needs')}
                            title={'Needs'}
                            id={'needs' + tabelID}
                        >
                            <div className="d-flex align-items-center">
                                <i className="ri-file-list-2-line fs-20 fw-medium" />
                            </div>
                        </Button>
                    </>
                );
                break;
            case 'checkEligibility':
                body = (
                    <>
                        <Button
                            type="button"
                            size="sm"
                            color="soft-info"
                            // outline="success"
                            onClick={() => onActionClick(cell, row, index, 'eligible')}
                            title={'Check Eligibility'}
                            id={'eligibility' + tabelID}
                        >
                            Check Eligibility
                        </Button>
                    </>
                );
                break;

            default:
                break;
        }
        return body;
    };
    return (
        <Fragment>
            <Card className={cardHeight}>
                {!hiderHeader && (
                    <CardHeader className={'d-flex align-items-center border-top ' + cardCSS?.header}>
                        <Col xs={6} sm={6} md={6} lg={6} xl={6} xxl={6} className="d-flex align-items-center">
                            {cardTitle && (
                                <h4 className="card-title flex-shrink-1 mb-0">
                                    {cardTitle} {allDataObj?.totalRecords && data?.length > 0 ? '(' + allDataObj?.totalRecords + ')' : ''}
                                    {mandate && <span className="text-danger">*</span>}
                                </h4>
                            )}
                            {buttonLabel && (
                                <>
                                    {showButtonLabel && <h4 className="mb-0">{buttonLabel}</h4>}
                                    <button
                                        type="button"
                                        className="btn btn-soft-primary btn-sm me-2 ms-2 rounded-pill sm-btn"
                                        onClick={onGlobalBtnClick}
                                        title={buttonLabel}
                                        id={'add' + tabelID}
                                    >
                                        <i className="ri-add-fill fs-18 fw-bold"></i>
                                        {/* {buttonLabel} */}
                                    </button>
                                </>
                            )}

                            <div className="search-box mb-0 d-inline-block ms-5">
                                <div className="position-relative">
                                    <div htmlFor="search-bar-0" className="search-label">
                                        {/* <span id="search-bar-0-label" className="sr-only">
                                Search this table
                            </span> */}
                                        <input
                                            onChange={(e) => {
                                                setSearchText(e.target.value);
                                                handleSearch(e.target.value);
                                            }}
                                            id={'search-bar-0' + tabelID}
                                            type="text"
                                            className="form-control"
                                            placeholder={'Search member name'}
                                            value={searchText || ''}
                                        />
                                    </div>
                                    <i className="ri-search-line search-widget-icon search-icon"></i>
                                </div>
                            </div>
                        </Col>
                        <Col
                            xs={6}
                            sm={6}
                            md={6}
                            lg={6}
                            xl={6}
                            xxl={6}
                            className="flex-shrink-0 d-flex align-items-center justify-content-end gap-1"
                        >
                            {hasToogle && (
                                <div className="ms-1 header-item height-30 d-none d-sm-flex">
                                    <button
                                        onClick={toggleFullscreen}
                                        type="button"
                                        className="btn btn-icon btn-topbar btn-ghost-primary rounded-circle"
                                    >
                                        <i className={isFullScreenMode ? 'ri-fullscreen-line fs-22' : 'ri-fullscreen-exit-line fs-22'}></i>
                                    </button>
                                </div>
                            )}
                            {!!generateButton && (
                                <Button
                                    type="button"
                                    size="md"
                                    color="success"
                                    outline
                                    onClick={() => onActionClick(null, null, null, 'generateLink')}
                                    className="ms-2"
                                    title={generateButton}
                                    id={generateButton}
                                >
                                    {generateButton}
                                </Button>
                            )}
                        </Col>
                    </CardHeader>
                )}
                <CardBody>
                    {loading ? (
                        tableLoader ? (
                            <TableSkelton />
                        ) : (
                            <CommonLoadingSkelton />
                        )
                    ) : (
                        <div className={divClass}>
                            <Table hover={data?.length > 0} {...getTableProps()} className={tableClass} id={tabelID}>
                                <thead className={theadClass}>
                                    {headerGroups.map((headerGroup, index) => (
                                        <tr className={trClass} key={headerGroup.id + index} {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map((column, ind) => (
                                                <th
                                                    key={column.id + ind}
                                                    className={column.thClass}
                                                    width={column.width}
                                                    {...(column.sortable ? column.getSortByToggleProps() : '')}
                                                    {...column.getHeaderProps({
                                                        // style: { width: column.width }
                                                    })}
                                                >
                                                    {column.render('Header')}
                                                    {/* {generateSortingIndicator(column)} */}
                                                    {/* <Filter column={column} /> */}
                                                </th>
                                            ))}
                                        </tr>
                                    ))}
                                </thead>

                                <tbody {...getTableBodyProps()}>
                                    {page?.length > 0 ? (
                                        page.map((row, index) => {
                                            prepareRow(row);
                                            return (
                                                <Fragment key={row.getRowProps().key}>
                                                    <tr>
                                                        {row.cells.map((cell, idx) => {
                                                            return (
                                                                <td key={cell.id + idx} {...cell.getCellProps()}>
                                                                    {cell.column.customCell ? (
                                                                        prepareCustomBody(cell, row, index)
                                                                    ) : cell.value === '' ? (
                                                                        <span className="text-muted">NA</span>
                                                                    ) : cell.column.twoLines ? (
                                                                        <p className="m-0" title={cell.value}>
                                                                            {cell.value?.length > 90
                                                                                ? getPartOfTheStrUptoRequiredIndex(cell.value, 0, 90)
                                                                                : cell.render('Cell')}
                                                                        </p>
                                                                    ) : (
                                                                        // <p className="m-0" title={cell.value}>
                                                                        <p className={`m-0 ${cell?.column?.classess}`} title={cell.value}>
                                                                            {cell.column.checkActive &&
                                                                                (row.original.isActive === 'Yes' ||
                                                                                row.original.isActive === true ? (
                                                                                    <i
                                                                                        className="ri-user-follow-line align-middle fs-16 text-primary me-2"
                                                                                        title="Active"
                                                                                    ></i>
                                                                                ) : (
                                                                                    <i
                                                                                        className="ri-user-unfollow-line align-middle fs-16 text-danger me-2"
                                                                                        title="Inactvie"
                                                                                    ></i>
                                                                                ))}
                                                                            {cell.render('Cell')}
                                                                        </p>
                                                                    )}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                </Fragment>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td className="fs-14" colSpan={columns?.length}>
                                                {emptyMessage ? emptyMessage : 'No Records Found.'}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {!loading && data?.length > 10 && (
                        <Pagination
                            activePage={activePage}
                            itemsCountPerPage={showRowsPerPage ? rowsPerPage.value || 10 : customPageSize}
                            totalItemsCount={allDataObj?.totalRecords || data?.length}
                            pageRangeDisplayed={3}
                            onChange={handlePageChange}
                            hideFirstLastPages={true}
                            recordsPerPageTemplate={recordsPerPageTemplate()}
                            showRowsPerPage={showRowsPerPage}
                        />
                    )}
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default DashboardTable;
